import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, filterBy, process } from '@progress/kendo-data-query';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { images } from 'src/app/resources/images';
import { DialogService } from '@progress/kendo-angular-dialog';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { NotificationService } from '@progress/kendo-angular-notification';
import { User } from 'src/app/global-functions';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { DatePipe } from '@angular/common'
import { FormGroup, FormControl } from '@angular/forms';
import { MovementLUG } from 'src/app/models/movementlug.model';
import { Reservations } from 'src/app/models/reservations.model';
import { Token } from '@angular/compiler';
import { ReservationsTokenComponent } from '../reservations-token/reservations-token.component';
import { ReservationsPaymentComponent } from '../reservations-payment/reservations-payment.component';
import { SharingService } from 'src/app/services/sharing.service';


@Component({
    selector: 'app-reservations',
    templateUrl: './reservations.component.html'
})
export class ReservationsComponent implements OnInit {
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public formGroup: FormGroup = new FormGroup({});
    public gridData: Reservations[] = [];
    public gridView: any[] = [];
    public filter: CompositeFilterDescriptor | undefined;
    public mySelection: string[] = [];
    public customMsgService: CustomMessagesService;
    datePipe: any;

    constructor(public msgService: MessageService,private sharingService: SharingService,
        private dialogService: DialogService, private api: ApiService, private notificationService: NotificationService, private datepipe: DatePipe) {
        this.customMsgService = this.msgService as CustomMessagesService;
        this.allData = this.allData.bind(this);

        this.formGroup = new FormGroup({
            dataDe: new FormControl(),
            dataAte: new FormControl(),
        });
    }

    public load() {
        let hoje = new Date();
        let mesPassado = new Date(new Date().setMonth(new Date().getMonth() - 1));

        this.formGroup.controls['dataDe'].setValue(mesPassado);
        this.formGroup.controls['dataAte'].setValue(hoje);

        let dataDe = this.datepipe.transform(this.formGroup.controls['dataDe'].value, 'yyyy-MM-dd');
        let dataAte = this.datepipe.transform(this.formGroup.controls['dataAte'].value, 'yyyy-MM-dd');
        let uri = "Reserva/GetReservas?inicio=" + dataDe + "&fim=" + dataAte;

        this.api
            .getRequest<BaseHttpResponse<Reservations[]>>(uri)
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => { });
    }

    public loadPesquisa() {
        let dataDe = this.datepipe.transform(this.formGroup.controls['dataDe'].value, 'yyyy-MM-dd');
        let dataAte = this.datepipe.transform(this.formGroup.controls['dataAte'].value, 'yyyy-MM-dd');
        let uri = "Reserva/GetReservas?inicio=" + dataDe + "&fim=" + dataAte;

        this.api
            .getRequest<BaseHttpResponse<Reservations[]>>(uri)
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => { });
    }

    public ngOnInit(): void {
        this.gridView = this.gridData;
        this.load();
    }

    public onTeamChange(pageSize: number): void {
        pageSize === 25
            ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
            : (this.gridView = this.gridData.slice(0, pageSize));
    }

    public onFilter(inputValue: string): void {
        let formattedFilter = inputValue;
        if (this.isDateInput(inputValue)) {
            formattedFilter = this.datePipe.transform(inputValue, 'yyyy-MM-ddTHH:mm:ss');
        }
    
        this.gridView = process(this.gridData, {
            filter: {
                logic: 'or',
                filters: [
                    {
                        field: this.getField,
                        operator: 'contains',
                        value: formattedFilter
                    }
                ]
            }
        }).data;
    
        if (this.dataBinding) {
            this.dataBinding.skip = 0;
        }
    }

    private isDateInput(value: string): boolean {
        // Implementação simples para verificar se o valor é uma data
        return /\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}/.test(value);
    }

    public getField = (args: Reservations) => {
        var data = this.datepipe.transform(args.dataRegistoServidor, 'yyyy-MM-dd HH:mm:ss')
        return `{data: ${data}, dataRegistoServidor: ${args.dataRegistoServidor}, refUtilizador: ${args.refUtilizador}, refArmarioModuloCompartimento: ${args.refArmarioModuloCompartimento}, nomeArmario: ${args.nomeArmario}, numeroDeSerieArmario: ${args.numeroDeSerieArmario}, nomeCompartimento: ${args.nomeCompartimento}, dataCriacao: ${args.dataCriacao}, reservaUID: ${args.reservaUID}, horasReservadas: ${args.horasReservadas}, taxaHoraExtra: ${args.taxaHoraExtra}, tamanhoCacifo: ${args.tamanhoCacifo}, validaApos: ${args.validaApos}, validaAntes: ${args.validaAntes}, validaAte: ${args.validaAte}, pagaAte: ${args.pagaAte}, primeiraAbertura: ${args.primeiraAbertura}, ultimaAbertura: ${args.ultimaAbertura}, tokens: ${args.tokens}, estado: ${args.estado}, descricaoEstado: ${args.descricaoEstado}, pagamentos: ${args.pagamentos}`;
    }

    public photoURL(dataItem: any): string {
        const code: string = dataItem.imgId;
        const image: any = images;

        return image[code];
    }

    public flagURL(dataItem: any): string {
        const code: string = dataItem.country;
        const image: any = images;

        return image[code];
    }

    canList() {
        return User.canMovimentosList();
    }

    public allData(): ExcelExportData {
        const result: ExcelExportData = {
            data: process(this.gridView, { filter: this.filter }).data.map((item: Reservations) => {
                return {
                    ...item,
                    dataRegistoServidor: this.datepipe.transform(item.dataRegistoServidor, 'yyyy-MM-dd HH:mm:ss'),
                    dataCriacao: this.datepipe.transform(item.dataCriacao, 'yyyy-MM-dd HH:mm:ss'),
                    validaApos: this.datepipe.transform(item.validaApos, 'yyyy-MM-dd HH:mm:ss'),
                    validaAntes: this.datepipe.transform(item.validaAntes, 'yyyy-MM-dd HH:mm:ss'),
                    validaAte: this.datepipe.transform(item.validaAte, 'yyyy-MM-dd HH:mm:ss'),
                    pagaAte: this.datepipe.transform(item.pagaAte, 'yyyy-MM-dd HH:mm:ss'),
                    primeiraAbertura: this.datepipe.transform(item.primeiraAbertura, 'yyyy-MM-dd HH:mm:ss'),
                    ultimaAbertura: this.datepipe.transform(item.ultimaAbertura, 'yyyy-MM-dd HH:mm:ss')
                };
            }),
        };
        return result;
    }

    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.gridData = filterBy(this.gridView, filter);
    }

    public openTokenFrom(r: Reservations) {
        this.sharingService.sharingValue = r;
        const dialogRef = this.dialogService.open({
            title: this.customMsgService.translate('tipoAcesso'),
            content: ReservationsTokenComponent,
        })
        const tokenInfo = dialogRef.content.instance as ReservationsTokenComponent;
        tokenInfo.formValue = r;
        tokenInfo.setFormValues();
    }

    public openPaymentForm(r: Reservations) {
        this.sharingService.sharingValue = r;
        const dialogRef = this.dialogService.open({
            title: this.customMsgService.translate('pagamentos'),
            content: ReservationsPaymentComponent,
        })
        const paymentInfo = dialogRef.content.instance as ReservationsPaymentComponent;
        paymentInfo.formValue = r;
        paymentInfo.setFormValues();
    }


    public pesquisar(): void {
        let dataDe = this.formGroup.controls['dataDe'].value;
        let dataAte = this.formGroup.controls['dataAte'].value;
        if (dataDe == null || dataAte == null) {
            this.notificationService.show({
                appendTo: this.container,
                content: this.customMsgService.translate('preencherIntervaloDatas'),
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'error', icon: true },
                hideAfter: 4000
            });

        } else {
            this.loadPesquisa();
        }
    }
}
